/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as SustainableDevelopmentGoalsRouteImport } from './../routes/sustainable-development-goals/route'
import { Route as MethodologiesRouteImport } from './../routes/methodologies/route'
import { Route as ImpactKpisRouteImport } from './../routes/impact-kpis/route'
import { Route as DefinitionsRouteImport } from './../routes/definitions/route'
import { Route as AcknowledgementsRouteImport } from './../routes/acknowledgements/route'
import { Route as IndexRouteImport } from './../routes/index/route'
import { Route as ImpactKpisLayoutImport } from './../routes/impact-kpis/_layout'
import { Route as ImpactKpisLayoutScope1And2EmissionsIndexImport } from './../routes/impact-kpis/_layout/scope-1-and-2-emissions/index'
import { Route as ImpactKpisLayoutLandRestoredIndexImport } from './../routes/impact-kpis/_layout/land-restored/index'
import { Route as ImpactKpisLayoutLandProtectedIndexImport } from './../routes/impact-kpis/_layout/land-protected/index'
import { Route as ImpactKpisLayoutLandManagedIndexImport } from './../routes/impact-kpis/_layout/land-managed/index'
import { Route as ImpactKpisLayoutInvesteeRevenueGrowthIndexImport } from './../routes/impact-kpis/_layout/investee-revenue-growth/index'
import { Route as ImpactKpisLayoutEmissionsRemovedIndexImport } from './../routes/impact-kpis/_layout/emissions-removed/index'
import { Route as ImpactKpisLayoutDecentJobsIndexImport } from './../routes/impact-kpis/_layout/decent-jobs/index'
import { Route as ImpactKpisLayoutCommunityBeneficiariesIndexImport } from './../routes/impact-kpis/_layout/community-beneficiaries/index'
import { Route as ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/index'
import { Route as ImpactKpisLayoutLandRestoredSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/land-restored/supporting-metrics/index'
import { Route as ImpactKpisLayoutLandProtectedSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/land-protected/supporting-metrics/index'
import { Route as ImpactKpisLayoutLandManagedSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/land-managed/supporting-metrics/index'
import { Route as ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/index'
import { Route as ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/emissions-removed/supporting-metrics/index'
import { Route as ImpactKpisLayoutDecentJobsSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/decent-jobs/supporting-metrics/index'
import { Route as ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexImport } from './../routes/impact-kpis/_layout/community-beneficiaries/supporting-metrics/index'

// Create/Update Routes

const SustainableDevelopmentGoalsRouteRoute =
  SustainableDevelopmentGoalsRouteImport.update({
    id: '/sustainable-development-goals',
    path: '/sustainable-development-goals',
    getParentRoute: () => rootRoute,
  } as any)

const MethodologiesRouteRoute = MethodologiesRouteImport.update({
  id: '/methodologies',
  path: '/methodologies',
  getParentRoute: () => rootRoute,
} as any)

const ImpactKpisRouteRoute = ImpactKpisRouteImport.update({
  id: '/impact-kpis',
  path: '/impact-kpis',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsRouteRoute = DefinitionsRouteImport.update({
  id: '/definitions',
  path: '/definitions',
  getParentRoute: () => rootRoute,
} as any)

const AcknowledgementsRouteRoute = AcknowledgementsRouteImport.update({
  id: '/acknowledgements',
  path: '/acknowledgements',
  getParentRoute: () => rootRoute,
} as any)

const IndexRouteRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ImpactKpisLayoutRoute = ImpactKpisLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => ImpactKpisRouteRoute,
} as any)

const ImpactKpisLayoutScope1And2EmissionsIndexRoute =
  ImpactKpisLayoutScope1And2EmissionsIndexImport.update({
    id: '/scope-1-and-2-emissions/',
    path: '/scope-1-and-2-emissions/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandRestoredIndexRoute =
  ImpactKpisLayoutLandRestoredIndexImport.update({
    id: '/land-restored/',
    path: '/land-restored/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandProtectedIndexRoute =
  ImpactKpisLayoutLandProtectedIndexImport.update({
    id: '/land-protected/',
    path: '/land-protected/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandManagedIndexRoute =
  ImpactKpisLayoutLandManagedIndexImport.update({
    id: '/land-managed/',
    path: '/land-managed/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute =
  ImpactKpisLayoutInvesteeRevenueGrowthIndexImport.update({
    id: '/investee-revenue-growth/',
    path: '/investee-revenue-growth/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutEmissionsRemovedIndexRoute =
  ImpactKpisLayoutEmissionsRemovedIndexImport.update({
    id: '/emissions-removed/',
    path: '/emissions-removed/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutDecentJobsIndexRoute =
  ImpactKpisLayoutDecentJobsIndexImport.update({
    id: '/decent-jobs/',
    path: '/decent-jobs/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutCommunityBeneficiariesIndexRoute =
  ImpactKpisLayoutCommunityBeneficiariesIndexImport.update({
    id: '/community-beneficiaries/',
    path: '/community-beneficiaries/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute =
  ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexImport.update({
    id: '/scope-1-and-2-emissions/supporting-metrics/',
    path: '/scope-1-and-2-emissions/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute =
  ImpactKpisLayoutLandRestoredSupportingMetricsIndexImport.update({
    id: '/land-restored/supporting-metrics/',
    path: '/land-restored/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute =
  ImpactKpisLayoutLandProtectedSupportingMetricsIndexImport.update({
    id: '/land-protected/supporting-metrics/',
    path: '/land-protected/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute =
  ImpactKpisLayoutLandManagedSupportingMetricsIndexImport.update({
    id: '/land-managed/supporting-metrics/',
    path: '/land-managed/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute =
  ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexImport.update({
    id: '/investee-revenue-growth/supporting-metrics/',
    path: '/investee-revenue-growth/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute =
  ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexImport.update({
    id: '/emissions-removed/supporting-metrics/',
    path: '/emissions-removed/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute =
  ImpactKpisLayoutDecentJobsSupportingMetricsIndexImport.update({
    id: '/decent-jobs/supporting-metrics/',
    path: '/decent-jobs/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

const ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute =
  ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexImport.update({
    id: '/community-beneficiaries/supporting-metrics/',
    path: '/community-beneficiaries/supporting-metrics/',
    getParentRoute: () => ImpactKpisLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/acknowledgements': {
      id: '/acknowledgements'
      path: '/acknowledgements'
      fullPath: '/acknowledgements'
      preLoaderRoute: typeof AcknowledgementsRouteImport
      parentRoute: typeof rootRoute
    }
    '/definitions': {
      id: '/definitions'
      path: '/definitions'
      fullPath: '/definitions'
      preLoaderRoute: typeof DefinitionsRouteImport
      parentRoute: typeof rootRoute
    }
    '/impact-kpis': {
      id: '/impact-kpis'
      path: '/impact-kpis'
      fullPath: '/impact-kpis'
      preLoaderRoute: typeof ImpactKpisRouteImport
      parentRoute: typeof rootRoute
    }
    '/methodologies': {
      id: '/methodologies'
      path: '/methodologies'
      fullPath: '/methodologies'
      preLoaderRoute: typeof MethodologiesRouteImport
      parentRoute: typeof rootRoute
    }
    '/sustainable-development-goals': {
      id: '/sustainable-development-goals'
      path: '/sustainable-development-goals'
      fullPath: '/sustainable-development-goals'
      preLoaderRoute: typeof SustainableDevelopmentGoalsRouteImport
      parentRoute: typeof rootRoute
    }
    '/impact-kpis/_layout': {
      id: '/impact-kpis/_layout'
      path: ''
      fullPath: '/impact-kpis'
      preLoaderRoute: typeof ImpactKpisLayoutImport
      parentRoute: typeof ImpactKpisRouteImport
    }
    '/impact-kpis/_layout/community-beneficiaries/': {
      id: '/impact-kpis/_layout/community-beneficiaries/'
      path: '/community-beneficiaries'
      fullPath: '/impact-kpis/community-beneficiaries'
      preLoaderRoute: typeof ImpactKpisLayoutCommunityBeneficiariesIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/decent-jobs/': {
      id: '/impact-kpis/_layout/decent-jobs/'
      path: '/decent-jobs'
      fullPath: '/impact-kpis/decent-jobs'
      preLoaderRoute: typeof ImpactKpisLayoutDecentJobsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/emissions-removed/': {
      id: '/impact-kpis/_layout/emissions-removed/'
      path: '/emissions-removed'
      fullPath: '/impact-kpis/emissions-removed'
      preLoaderRoute: typeof ImpactKpisLayoutEmissionsRemovedIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/investee-revenue-growth/': {
      id: '/impact-kpis/_layout/investee-revenue-growth/'
      path: '/investee-revenue-growth'
      fullPath: '/impact-kpis/investee-revenue-growth'
      preLoaderRoute: typeof ImpactKpisLayoutInvesteeRevenueGrowthIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-managed/': {
      id: '/impact-kpis/_layout/land-managed/'
      path: '/land-managed'
      fullPath: '/impact-kpis/land-managed'
      preLoaderRoute: typeof ImpactKpisLayoutLandManagedIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-protected/': {
      id: '/impact-kpis/_layout/land-protected/'
      path: '/land-protected'
      fullPath: '/impact-kpis/land-protected'
      preLoaderRoute: typeof ImpactKpisLayoutLandProtectedIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-restored/': {
      id: '/impact-kpis/_layout/land-restored/'
      path: '/land-restored'
      fullPath: '/impact-kpis/land-restored'
      preLoaderRoute: typeof ImpactKpisLayoutLandRestoredIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/scope-1-and-2-emissions/': {
      id: '/impact-kpis/_layout/scope-1-and-2-emissions/'
      path: '/scope-1-and-2-emissions'
      fullPath: '/impact-kpis/scope-1-and-2-emissions'
      preLoaderRoute: typeof ImpactKpisLayoutScope1And2EmissionsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/community-beneficiaries/supporting-metrics/': {
      id: '/impact-kpis/_layout/community-beneficiaries/supporting-metrics/'
      path: '/community-beneficiaries/supporting-metrics'
      fullPath: '/impact-kpis/community-beneficiaries/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/decent-jobs/supporting-metrics/': {
      id: '/impact-kpis/_layout/decent-jobs/supporting-metrics/'
      path: '/decent-jobs/supporting-metrics'
      fullPath: '/impact-kpis/decent-jobs/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutDecentJobsSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/emissions-removed/supporting-metrics/': {
      id: '/impact-kpis/_layout/emissions-removed/supporting-metrics/'
      path: '/emissions-removed/supporting-metrics'
      fullPath: '/impact-kpis/emissions-removed/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/': {
      id: '/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/'
      path: '/investee-revenue-growth/supporting-metrics'
      fullPath: '/impact-kpis/investee-revenue-growth/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-managed/supporting-metrics/': {
      id: '/impact-kpis/_layout/land-managed/supporting-metrics/'
      path: '/land-managed/supporting-metrics'
      fullPath: '/impact-kpis/land-managed/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutLandManagedSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-protected/supporting-metrics/': {
      id: '/impact-kpis/_layout/land-protected/supporting-metrics/'
      path: '/land-protected/supporting-metrics'
      fullPath: '/impact-kpis/land-protected/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutLandProtectedSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/land-restored/supporting-metrics/': {
      id: '/impact-kpis/_layout/land-restored/supporting-metrics/'
      path: '/land-restored/supporting-metrics'
      fullPath: '/impact-kpis/land-restored/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutLandRestoredSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
    '/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/': {
      id: '/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/'
      path: '/scope-1-and-2-emissions/supporting-metrics'
      fullPath: '/impact-kpis/scope-1-and-2-emissions/supporting-metrics'
      preLoaderRoute: typeof ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexImport
      parentRoute: typeof ImpactKpisLayoutImport
    }
  }
}

// Create and export the route tree

interface ImpactKpisLayoutRouteChildren {
  ImpactKpisLayoutCommunityBeneficiariesIndexRoute: typeof ImpactKpisLayoutCommunityBeneficiariesIndexRoute
  ImpactKpisLayoutDecentJobsIndexRoute: typeof ImpactKpisLayoutDecentJobsIndexRoute
  ImpactKpisLayoutEmissionsRemovedIndexRoute: typeof ImpactKpisLayoutEmissionsRemovedIndexRoute
  ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute: typeof ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute
  ImpactKpisLayoutLandManagedIndexRoute: typeof ImpactKpisLayoutLandManagedIndexRoute
  ImpactKpisLayoutLandProtectedIndexRoute: typeof ImpactKpisLayoutLandProtectedIndexRoute
  ImpactKpisLayoutLandRestoredIndexRoute: typeof ImpactKpisLayoutLandRestoredIndexRoute
  ImpactKpisLayoutScope1And2EmissionsIndexRoute: typeof ImpactKpisLayoutScope1And2EmissionsIndexRoute
  ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute: typeof ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute
  ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute: typeof ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute
  ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute: typeof ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute
  ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute: typeof ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute
  ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute: typeof ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute
  ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute: typeof ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute
  ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute: typeof ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute
  ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute: typeof ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute
}

const ImpactKpisLayoutRouteChildren: ImpactKpisLayoutRouteChildren = {
  ImpactKpisLayoutCommunityBeneficiariesIndexRoute:
    ImpactKpisLayoutCommunityBeneficiariesIndexRoute,
  ImpactKpisLayoutDecentJobsIndexRoute: ImpactKpisLayoutDecentJobsIndexRoute,
  ImpactKpisLayoutEmissionsRemovedIndexRoute:
    ImpactKpisLayoutEmissionsRemovedIndexRoute,
  ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute:
    ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute,
  ImpactKpisLayoutLandManagedIndexRoute: ImpactKpisLayoutLandManagedIndexRoute,
  ImpactKpisLayoutLandProtectedIndexRoute:
    ImpactKpisLayoutLandProtectedIndexRoute,
  ImpactKpisLayoutLandRestoredIndexRoute:
    ImpactKpisLayoutLandRestoredIndexRoute,
  ImpactKpisLayoutScope1And2EmissionsIndexRoute:
    ImpactKpisLayoutScope1And2EmissionsIndexRoute,
  ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute:
    ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute,
  ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute:
    ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute,
  ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute:
    ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute,
  ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute:
    ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute,
  ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute:
    ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute,
  ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute:
    ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute,
  ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute:
    ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute,
  ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute:
    ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute,
}

const ImpactKpisLayoutRouteWithChildren =
  ImpactKpisLayoutRoute._addFileChildren(ImpactKpisLayoutRouteChildren)

interface ImpactKpisRouteRouteChildren {
  ImpactKpisLayoutRoute: typeof ImpactKpisLayoutRouteWithChildren
}

const ImpactKpisRouteRouteChildren: ImpactKpisRouteRouteChildren = {
  ImpactKpisLayoutRoute: ImpactKpisLayoutRouteWithChildren,
}

const ImpactKpisRouteRouteWithChildren = ImpactKpisRouteRoute._addFileChildren(
  ImpactKpisRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/acknowledgements': typeof AcknowledgementsRouteRoute
  '/definitions': typeof DefinitionsRouteRoute
  '/impact-kpis': typeof ImpactKpisLayoutRouteWithChildren
  '/methodologies': typeof MethodologiesRouteRoute
  '/sustainable-development-goals': typeof SustainableDevelopmentGoalsRouteRoute
  '/impact-kpis/community-beneficiaries': typeof ImpactKpisLayoutCommunityBeneficiariesIndexRoute
  '/impact-kpis/decent-jobs': typeof ImpactKpisLayoutDecentJobsIndexRoute
  '/impact-kpis/emissions-removed': typeof ImpactKpisLayoutEmissionsRemovedIndexRoute
  '/impact-kpis/investee-revenue-growth': typeof ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute
  '/impact-kpis/land-managed': typeof ImpactKpisLayoutLandManagedIndexRoute
  '/impact-kpis/land-protected': typeof ImpactKpisLayoutLandProtectedIndexRoute
  '/impact-kpis/land-restored': typeof ImpactKpisLayoutLandRestoredIndexRoute
  '/impact-kpis/scope-1-and-2-emissions': typeof ImpactKpisLayoutScope1And2EmissionsIndexRoute
  '/impact-kpis/community-beneficiaries/supporting-metrics': typeof ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute
  '/impact-kpis/decent-jobs/supporting-metrics': typeof ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute
  '/impact-kpis/emissions-removed/supporting-metrics': typeof ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute
  '/impact-kpis/investee-revenue-growth/supporting-metrics': typeof ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute
  '/impact-kpis/land-managed/supporting-metrics': typeof ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute
  '/impact-kpis/land-protected/supporting-metrics': typeof ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute
  '/impact-kpis/land-restored/supporting-metrics': typeof ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute
  '/impact-kpis/scope-1-and-2-emissions/supporting-metrics': typeof ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/acknowledgements': typeof AcknowledgementsRouteRoute
  '/definitions': typeof DefinitionsRouteRoute
  '/impact-kpis': typeof ImpactKpisLayoutRouteWithChildren
  '/methodologies': typeof MethodologiesRouteRoute
  '/sustainable-development-goals': typeof SustainableDevelopmentGoalsRouteRoute
  '/impact-kpis/community-beneficiaries': typeof ImpactKpisLayoutCommunityBeneficiariesIndexRoute
  '/impact-kpis/decent-jobs': typeof ImpactKpisLayoutDecentJobsIndexRoute
  '/impact-kpis/emissions-removed': typeof ImpactKpisLayoutEmissionsRemovedIndexRoute
  '/impact-kpis/investee-revenue-growth': typeof ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute
  '/impact-kpis/land-managed': typeof ImpactKpisLayoutLandManagedIndexRoute
  '/impact-kpis/land-protected': typeof ImpactKpisLayoutLandProtectedIndexRoute
  '/impact-kpis/land-restored': typeof ImpactKpisLayoutLandRestoredIndexRoute
  '/impact-kpis/scope-1-and-2-emissions': typeof ImpactKpisLayoutScope1And2EmissionsIndexRoute
  '/impact-kpis/community-beneficiaries/supporting-metrics': typeof ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute
  '/impact-kpis/decent-jobs/supporting-metrics': typeof ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute
  '/impact-kpis/emissions-removed/supporting-metrics': typeof ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute
  '/impact-kpis/investee-revenue-growth/supporting-metrics': typeof ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute
  '/impact-kpis/land-managed/supporting-metrics': typeof ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute
  '/impact-kpis/land-protected/supporting-metrics': typeof ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute
  '/impact-kpis/land-restored/supporting-metrics': typeof ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute
  '/impact-kpis/scope-1-and-2-emissions/supporting-metrics': typeof ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRouteRoute
  '/acknowledgements': typeof AcknowledgementsRouteRoute
  '/definitions': typeof DefinitionsRouteRoute
  '/impact-kpis': typeof ImpactKpisRouteRouteWithChildren
  '/methodologies': typeof MethodologiesRouteRoute
  '/sustainable-development-goals': typeof SustainableDevelopmentGoalsRouteRoute
  '/impact-kpis/_layout': typeof ImpactKpisLayoutRouteWithChildren
  '/impact-kpis/_layout/community-beneficiaries/': typeof ImpactKpisLayoutCommunityBeneficiariesIndexRoute
  '/impact-kpis/_layout/decent-jobs/': typeof ImpactKpisLayoutDecentJobsIndexRoute
  '/impact-kpis/_layout/emissions-removed/': typeof ImpactKpisLayoutEmissionsRemovedIndexRoute
  '/impact-kpis/_layout/investee-revenue-growth/': typeof ImpactKpisLayoutInvesteeRevenueGrowthIndexRoute
  '/impact-kpis/_layout/land-managed/': typeof ImpactKpisLayoutLandManagedIndexRoute
  '/impact-kpis/_layout/land-protected/': typeof ImpactKpisLayoutLandProtectedIndexRoute
  '/impact-kpis/_layout/land-restored/': typeof ImpactKpisLayoutLandRestoredIndexRoute
  '/impact-kpis/_layout/scope-1-and-2-emissions/': typeof ImpactKpisLayoutScope1And2EmissionsIndexRoute
  '/impact-kpis/_layout/community-beneficiaries/supporting-metrics/': typeof ImpactKpisLayoutCommunityBeneficiariesSupportingMetricsIndexRoute
  '/impact-kpis/_layout/decent-jobs/supporting-metrics/': typeof ImpactKpisLayoutDecentJobsSupportingMetricsIndexRoute
  '/impact-kpis/_layout/emissions-removed/supporting-metrics/': typeof ImpactKpisLayoutEmissionsRemovedSupportingMetricsIndexRoute
  '/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/': typeof ImpactKpisLayoutInvesteeRevenueGrowthSupportingMetricsIndexRoute
  '/impact-kpis/_layout/land-managed/supporting-metrics/': typeof ImpactKpisLayoutLandManagedSupportingMetricsIndexRoute
  '/impact-kpis/_layout/land-protected/supporting-metrics/': typeof ImpactKpisLayoutLandProtectedSupportingMetricsIndexRoute
  '/impact-kpis/_layout/land-restored/supporting-metrics/': typeof ImpactKpisLayoutLandRestoredSupportingMetricsIndexRoute
  '/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/': typeof ImpactKpisLayoutScope1And2EmissionsSupportingMetricsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/acknowledgements'
    | '/definitions'
    | '/impact-kpis'
    | '/methodologies'
    | '/sustainable-development-goals'
    | '/impact-kpis/community-beneficiaries'
    | '/impact-kpis/decent-jobs'
    | '/impact-kpis/emissions-removed'
    | '/impact-kpis/investee-revenue-growth'
    | '/impact-kpis/land-managed'
    | '/impact-kpis/land-protected'
    | '/impact-kpis/land-restored'
    | '/impact-kpis/scope-1-and-2-emissions'
    | '/impact-kpis/community-beneficiaries/supporting-metrics'
    | '/impact-kpis/decent-jobs/supporting-metrics'
    | '/impact-kpis/emissions-removed/supporting-metrics'
    | '/impact-kpis/investee-revenue-growth/supporting-metrics'
    | '/impact-kpis/land-managed/supporting-metrics'
    | '/impact-kpis/land-protected/supporting-metrics'
    | '/impact-kpis/land-restored/supporting-metrics'
    | '/impact-kpis/scope-1-and-2-emissions/supporting-metrics'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/acknowledgements'
    | '/definitions'
    | '/impact-kpis'
    | '/methodologies'
    | '/sustainable-development-goals'
    | '/impact-kpis/community-beneficiaries'
    | '/impact-kpis/decent-jobs'
    | '/impact-kpis/emissions-removed'
    | '/impact-kpis/investee-revenue-growth'
    | '/impact-kpis/land-managed'
    | '/impact-kpis/land-protected'
    | '/impact-kpis/land-restored'
    | '/impact-kpis/scope-1-and-2-emissions'
    | '/impact-kpis/community-beneficiaries/supporting-metrics'
    | '/impact-kpis/decent-jobs/supporting-metrics'
    | '/impact-kpis/emissions-removed/supporting-metrics'
    | '/impact-kpis/investee-revenue-growth/supporting-metrics'
    | '/impact-kpis/land-managed/supporting-metrics'
    | '/impact-kpis/land-protected/supporting-metrics'
    | '/impact-kpis/land-restored/supporting-metrics'
    | '/impact-kpis/scope-1-and-2-emissions/supporting-metrics'
  id:
    | '__root__'
    | '/'
    | '/acknowledgements'
    | '/definitions'
    | '/impact-kpis'
    | '/methodologies'
    | '/sustainable-development-goals'
    | '/impact-kpis/_layout'
    | '/impact-kpis/_layout/community-beneficiaries/'
    | '/impact-kpis/_layout/decent-jobs/'
    | '/impact-kpis/_layout/emissions-removed/'
    | '/impact-kpis/_layout/investee-revenue-growth/'
    | '/impact-kpis/_layout/land-managed/'
    | '/impact-kpis/_layout/land-protected/'
    | '/impact-kpis/_layout/land-restored/'
    | '/impact-kpis/_layout/scope-1-and-2-emissions/'
    | '/impact-kpis/_layout/community-beneficiaries/supporting-metrics/'
    | '/impact-kpis/_layout/decent-jobs/supporting-metrics/'
    | '/impact-kpis/_layout/emissions-removed/supporting-metrics/'
    | '/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/'
    | '/impact-kpis/_layout/land-managed/supporting-metrics/'
    | '/impact-kpis/_layout/land-protected/supporting-metrics/'
    | '/impact-kpis/_layout/land-restored/supporting-metrics/'
    | '/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  AcknowledgementsRouteRoute: typeof AcknowledgementsRouteRoute
  DefinitionsRouteRoute: typeof DefinitionsRouteRoute
  ImpactKpisRouteRoute: typeof ImpactKpisRouteRouteWithChildren
  MethodologiesRouteRoute: typeof MethodologiesRouteRoute
  SustainableDevelopmentGoalsRouteRoute: typeof SustainableDevelopmentGoalsRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  AcknowledgementsRouteRoute: AcknowledgementsRouteRoute,
  DefinitionsRouteRoute: DefinitionsRouteRoute,
  ImpactKpisRouteRoute: ImpactKpisRouteRouteWithChildren,
  MethodologiesRouteRoute: MethodologiesRouteRoute,
  SustainableDevelopmentGoalsRouteRoute: SustainableDevelopmentGoalsRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/acknowledgements",
        "/definitions",
        "/impact-kpis",
        "/methodologies",
        "/sustainable-development-goals"
      ]
    },
    "/": {
      "filePath": "index/route.tsx"
    },
    "/acknowledgements": {
      "filePath": "acknowledgements/route.tsx"
    },
    "/definitions": {
      "filePath": "definitions/route.tsx"
    },
    "/impact-kpis": {
      "filePath": "impact-kpis/route.tsx",
      "children": [
        "/impact-kpis/_layout"
      ]
    },
    "/methodologies": {
      "filePath": "methodologies/route.tsx"
    },
    "/sustainable-development-goals": {
      "filePath": "sustainable-development-goals/route.tsx"
    },
    "/impact-kpis/_layout": {
      "filePath": "impact-kpis/_layout.tsx",
      "parent": "/impact-kpis",
      "children": [
        "/impact-kpis/_layout/community-beneficiaries/",
        "/impact-kpis/_layout/decent-jobs/",
        "/impact-kpis/_layout/emissions-removed/",
        "/impact-kpis/_layout/investee-revenue-growth/",
        "/impact-kpis/_layout/land-managed/",
        "/impact-kpis/_layout/land-protected/",
        "/impact-kpis/_layout/land-restored/",
        "/impact-kpis/_layout/scope-1-and-2-emissions/",
        "/impact-kpis/_layout/community-beneficiaries/supporting-metrics/",
        "/impact-kpis/_layout/decent-jobs/supporting-metrics/",
        "/impact-kpis/_layout/emissions-removed/supporting-metrics/",
        "/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/",
        "/impact-kpis/_layout/land-managed/supporting-metrics/",
        "/impact-kpis/_layout/land-protected/supporting-metrics/",
        "/impact-kpis/_layout/land-restored/supporting-metrics/",
        "/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/"
      ]
    },
    "/impact-kpis/_layout/community-beneficiaries/": {
      "filePath": "impact-kpis/_layout/community-beneficiaries/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/decent-jobs/": {
      "filePath": "impact-kpis/_layout/decent-jobs/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/emissions-removed/": {
      "filePath": "impact-kpis/_layout/emissions-removed/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/investee-revenue-growth/": {
      "filePath": "impact-kpis/_layout/investee-revenue-growth/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-managed/": {
      "filePath": "impact-kpis/_layout/land-managed/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-protected/": {
      "filePath": "impact-kpis/_layout/land-protected/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-restored/": {
      "filePath": "impact-kpis/_layout/land-restored/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/scope-1-and-2-emissions/": {
      "filePath": "impact-kpis/_layout/scope-1-and-2-emissions/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/community-beneficiaries/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/community-beneficiaries/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/decent-jobs/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/decent-jobs/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/emissions-removed/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/emissions-removed/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/investee-revenue-growth/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-managed/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/land-managed/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-protected/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/land-protected/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/land-restored/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/land-restored/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    },
    "/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/": {
      "filePath": "impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/index.tsx",
      "parent": "/impact-kpis/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
